// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OigoQDz5CvpLCf {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: var(--ds-text-inverse, #ffffff);
  font-size: 20px;
  font-weight: var(--ds-font-weight-bold, bold);
}
.OigoQDz5CvpLCf.gXeiNZdSQGX7bU {
  font-size: 16px;
}
.OigoQDz5CvpLCf.hHvLQiAje2sXMk {
  font-size: 12px;
}
.sCZ33cxQl8QMNy {
  background: linear-gradient(var(--ds-background-accent-blue-bolder, #0747a6), var(--ds-background-accent-teal-bolder, #008da6));
}
.V8VNIXQrkLAAwj {
  background: linear-gradient(var(--ds-background-accent-green-bolder, #006644), var(--ds-background-accent-green-subtle, #00875a));
}
.Sh5LsFrYiQUEHR {
  background: linear-gradient(var(--ds-background-accent-purple-bolder, #403294), var(--ds-background-accent-blue-bolder, #0747a6));
}
.zr_YtlKnhtFyEI {
  background: linear-gradient(var(--ds-background-accent-magenta-bolder, #b22865), var(--ds-background-accent-magenta-subtle, #cd5a91));
}
.zB0tZvbZU6jcjk {
  background: linear-gradient(var(--ds-background-accent-red-bolder, #cc4223), var(--ds-background-accent-orange-subtle, #cb7d25));
}
.Lq_vHuaLxPDtCx {
  background: var(--ds-background-neutral-bold, #42526e);
}
`, ""]);
// Exports
export var defaultLogoContainer = `OigoQDz5CvpLCf`;
export var xsmall = `gXeiNZdSQGX7bU`;
export var xxsmall = `hHvLQiAje2sXMk`;
var _1 = `sCZ33cxQl8QMNy`;
export { _1 as "defaultLogoGradient-teal" };
var _2 = `V8VNIXQrkLAAwj`;
export { _2 as "defaultLogoGradient-green" };
var _3 = `Sh5LsFrYiQUEHR`;
export { _3 as "defaultLogoGradient-blue" };
var _4 = `zr_YtlKnhtFyEI`;
export { _4 as "defaultLogoGradient-pink" };
var _5 = `zB0tZvbZU6jcjk`;
export { _5 as "defaultLogoGradient-orange" };
export var desaturateLogo = `Lq_vHuaLxPDtCx`;
export default ___CSS_LOADER_EXPORT___;
